import React from 'react'
import classnames from 'utils/classnames'

const mapStylesToLevel = {
  h1: 'text-5xl',
  h2: 'text-3xl',
  h3: 'text-xl',
  suptitle: 'text-xs mb-2 text-red-500 font-bold uppercase'
}

const mapColor = {
  red: 'text-red-500'
}

const Heading = ({ as = 'h2', styledAs, className, children, color, ...rest }) => {
  const hStyle = styledAs ? mapStylesToLevel[styledAs] : mapStylesToLevel[as];
  const colorStyle = color ? mapColor[color] : '';

  const rootClassnames = classnames('font-bold', hStyle, colorStyle, className);

  const Component = as;

  return (
    <Component className={rootClassnames} {...rest}>
      { children }
    </Component>
  )
}

export default Heading